module.exports = __webpack_public_path__ + "assets/img/mecha-5f8272ca.png";